module.exports = __webpack_public_path__ + "img/googlePagespeed.459115b8.png";